var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", { staticClass: "table" }, [
      _c("tr", [
        _c("th", [_vm._v("Frame")]),
        _c(
          "td",
          [
            _vm._v(
              _vm._s(_setup.frameDescription) +
                " (Ref: " +
                _vm._s(_setup.props.length.itemCode) +
                ")"
            ),
            _vm._l(
              _setup.props.validation.frame.problems,
              function (problem, idx) {
                return _c(
                  "p",
                  {
                    key: `frame-problem-${idx}`,
                    staticClass: "mb-0 text-danger",
                  },
                  [_vm._v(_vm._s(problem))]
                )
              }
            ),
            _vm._l(
              _setup.props.validation.frame.warnings,
              function (warning, idx) {
                return _c(
                  "p",
                  {
                    key: `frame-warning-${idx}`,
                    staticClass: "mb-0 text-warning",
                  },
                  [_vm._v(_vm._s(warning))]
                )
              }
            ),
          ],
          2
        ),
      ]),
      _c("tr", [
        _c("th", [_vm._v("Mount")]),
        _c(
          "td",
          { class: { "text-muted": !_setup.props.hasMount } },
          [
            _vm._v(
              _vm._s(
                _setup.props.hasMount
                  ? _setup.props.mount.name
                  : "No Mount Selected"
              )
            ),
            _vm._l(
              _setup.props.validation.mount.problems,
              function (problem, idx) {
                return _c(
                  "p",
                  {
                    key: `mount-problem-${idx}`,
                    staticClass: "mb-0 text-danger",
                  },
                  [_vm._v(_vm._s(problem))]
                )
              }
            ),
            _vm._l(
              _setup.props.validation.mount.warnings,
              function (warning, idx) {
                return _c(
                  "p",
                  {
                    key: `mount-warning-${idx}`,
                    staticClass: "mb-0 text-warning",
                  },
                  [_vm._v(_vm._s(warning))]
                )
              }
            ),
          ],
          2
        ),
      ]),
      _c("tr", [
        _c("th", [_vm._v("Glass")]),
        _c(
          "td",
          [
            _vm._v(
              _vm._s(
                _setup.props.glazing ? _setup.props.glazing.name : "Loading."
              )
            ),
            _vm._l(
              _setup.props.validation.glazing.problems,
              function (problem, idx) {
                return _c(
                  "p",
                  {
                    key: `glazing-problem-${idx}`,
                    staticClass: "mb-0 text-danger",
                  },
                  [_vm._v(_vm._s(problem))]
                )
              }
            ),
            _vm._l(
              _setup.props.validation.glazing.warnings,
              function (warning, idx) {
                return _c(
                  "p",
                  {
                    key: `glazing-warning-${idx}`,
                    staticClass: "mb-0 text-warning",
                  },
                  [_vm._v(_vm._s(warning))]
                )
              }
            ),
          ],
          2
        ),
      ]),
      _c("tr", [
        _c("th", [_vm._v("Extras")]),
        _c("td", [
          _vm._v(
            _vm._s(
              _setup.props.fixings == "hanger" ? "Hanger" : "D-rings and String"
            )
          ),
        ]),
      ]),
      _vm._m(0),
      _c("tr", { staticClass: "bg-light" }, [
        _c("th", [_vm._v("Unit Price")]),
        _c("td", [_vm._v("£" + _vm._s(_setup.props.unitPrice))]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [
      _c("th", [_vm._v("Backing")]),
      _c("td", [_vm._v("2.3mm Craftboard")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }